export type StaleVersionCacheLogger = (
  type: 'warn',
  payload: { component: string; message: string; messageContext: LooseObject },
) => void

export type ResetCacheOnStaleVersionOptions = {
  cache: string
  cachedVersion?: Maybe<string>
  freshVersion: string
  hasSelection: () => boolean
  log: StaleVersionCacheLogger
  productId: string
  reset: () => void
  syncVersion: (version: string) => void
}

export const resetCacheOnStaleVersion = ({
  cache,
  cachedVersion,
  freshVersion,
  hasSelection,
  log,
  productId,
  reset,
  syncVersion,
}: ResetCacheOnStaleVersionOptions) => {
  if (!cachedVersion || cachedVersion === freshVersion) {
    syncVersion(freshVersion)
    return false
  }

  const hadSelection = hasSelection()

  reset()
  syncVersion(freshVersion)

  if (hadSelection) {
    log('warn', {
      component: 'staleVersionCache',
      message: 'Cache reset because of an outdated config version',
      messageContext: {
        cache,
        cachedVersion,
        freshVersion,
        productId,
      },
    })
  }

  return true
}
